import React from 'react';
import TableView from '../tableView';
import { CompaniesResponse } from '../../Model/contact';
import { useTranslation } from 'react-i18next';

interface Props {
  companies: CompaniesResponse[],
  tabulator: any,
  filterSelectOptions: {}
}

export const CompaniesTable = ({
  filterSelectOptions,
  companies,
  tabulator
}: Props) => {
  const { t } = useTranslation();
  const companyColumns = [
    {
      title: t('BUSINESS_NAME'),
      field: 'businessName',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('COMPANY_CONTACT_ID'),
      field: 'companyContactId',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('KYB'),
      field: 'isKYBEnabled',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('SESSION_ID'),
      field: 'sessionId',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('TIER'),
      field: 'tier',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('VAT'),
      field: 'vat',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    }
  ];


  return <>  {companies.length > 0
    ? <TableView
      t={t}
      ref={tabulator}
      data={companies}
      columns={companyColumns}
      id={'company-list'} />
    : <p className='noData'>{t('NO_DATA')}</p>}
    </>;
};
